(function () {
  'use strict';

  /* Guard against the script being evaluated twice (theme editor section reloads). */
  if (window.__s9CaseStudyLoaded) return;
  window.__s9CaseStudyLoaded = true;

  var teardown = null;
  var ROOT_ID = 'studios-1209-case-study';

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

  function init(root) {
    if (!root || root.dataset.s9Ready) return;
    root.dataset.s9Ready = 'true';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var wide = window.matchMedia('(min-width: 990px)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var items = Array.prototype.slice.call(root.querySelectorAll('.s9-reveal'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-s9-depth]'));
    var hero = root.querySelector('[data-s9-pointer]');
    var demo = root.querySelector('[data-s9-logo]');
    var rail = root.querySelector('[data-s9-rail]');
    var bar = root.querySelector('[data-s9-rail-bar]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-s9-slide]'));
    var figs = Array.prototype.slice.call(root.querySelectorAll('.s9-fig'));
    var io = null;
    var ticking = false;
    var pointerFrame = 0;
    var cleanups = [];

    function motionOk() { return !reduced.matches; }
    function pointerOk() { return motionOk() && fine.matches && wide.matches; }

    function reveal(el) {
      el.classList.add('s9-is-visible');
      window.setTimeout(function () { el.style.transitionDelay = '0s'; }, 1800);
    }
    function showAll() {
      items.forEach(function (el) { el.classList.add('s9-is-visible'); el.style.transitionDelay = '0s'; });
    }

    /* Scroll reveals. The hidden state only exists once .s9-js is set, so content stays visible if this script never runs. */
    function startReveals() {
      if (io || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top > 0) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { if (!el.classList.contains('s9-is-visible')) io.observe(el); });
    }

    /* Scroll-linked movement: small depth shifts, the demo wordmark shrinking into its header, and photo parallax inside the rail. */
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      var vw = window.innerWidth || 1;
      var scale = wide.matches ? 1 : 0.4;
      layers.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -300 || rect.top > vh + 300) return;
        var factor = parseFloat(el.getAttribute('data-s9-depth')) || 0;
        var offset = (rect.top + rect.height / 2 - vh / 2) * factor * scale;
        el.style.setProperty('--s9-shift', clamp(offset, -30 * scale, 30 * scale).toFixed(1) + 'px');
      });
      if (demo) {
        var r = demo.getBoundingClientRect();
        var p = clamp((vh * 0.82 - r.top) / (vh * 0.5), 0, 1);
        demo.style.setProperty('--s9-lp', p.toFixed(3));
      }
      if (rail && slides.length) {
        var max = Math.max(rail.scrollWidth - rail.clientWidth, 1);
        if (bar) bar.style.setProperty('--s9-rail-p', (0.12 + clamp(rail.scrollLeft / max, 0, 1) * 0.88).toFixed(3));
        slides.forEach(function (slide) {
          var sr = slide.getBoundingClientRect();
          if (sr.right < -200 || sr.left > vw + 200) return;
          var shift = ((sr.left + sr.width / 2) - vw / 2) / vw;
          slide.style.setProperty('--s9-img-x', (clamp(shift, -1, 1) * -22 * scale).toFixed(1) + 'px');
        });
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function bindScroll() {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      if (rail) rail.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
    function unbindScroll() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (rail) rail.removeEventListener('scroll', onScroll);
      layers.forEach(function (el) { el.style.removeProperty('--s9-shift'); });
      slides.forEach(function (slide) { slide.style.removeProperty('--s9-img-x'); });
      if (demo) demo.style.removeProperty('--s9-lp');
    }

    /* Desktop pointer depth. Values are -1..1 CSS variables; leaving settles everything back to rest. */
    function bindPointer(el, xName, yName) {
      if (!el) return;
      var pending = null;
      function flush() {
        pointerFrame = 0;
        if (!pending) return;
        el.style.setProperty(xName, pending[0]);
        el.style.setProperty(yName, pending[1]);
        pending = null;
      }
      function onMove(event) {
        if (!pointerOk() || event.pointerType === 'touch') return;
        var rect = el.getBoundingClientRect();
        pending = [
          clamp(((event.clientX - rect.left) / rect.width) * 2 - 1, -1, 1).toFixed(3),
          clamp(((event.clientY - rect.top) / rect.height) * 2 - 1, -1, 1).toFixed(3)
        ];
        if (!pointerFrame) pointerFrame = window.requestAnimationFrame(flush);
      }
      function onLeave() {
        pending = null;
        el.style.setProperty(xName, '0');
        el.style.setProperty(yName, '0');
      }
      el.addEventListener('pointermove', onMove);
      el.addEventListener('pointerleave', onLeave);
      cleanups.push(function () {
        el.removeEventListener('pointermove', onMove);
        el.removeEventListener('pointerleave', onLeave);
        el.style.removeProperty(xName);
        el.style.removeProperty(yName);
      });
    }
    bindPointer(hero, '--s9-px', '--s9-py');
    figs.forEach(function (fig) { bindPointer(fig, '--s9-cx', '--s9-cy'); });

    /* Horizontal rail buttons. */
    var prev = root.querySelector('[data-s9-rail-prev]');
    var next = root.querySelector('[data-s9-rail-next]');
    function step(direction) {
      if (!rail) return;
      var amount = Math.max(rail.clientWidth * 0.7, 240) * direction;
      rail.scrollBy({ left: amount, behavior: motionOk() ? 'smooth' : 'auto' });
    }
    function onPrev() { step(-1); }
    function onNext() { step(1); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    cleanups.push(function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
    });

    /* Example Men / Women navigation (design prototype): opens on hover, focus or click, closes on Escape or outside click. */
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-s9-menu-btn]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-s9-panel]'));
    function openMenu(name) {
      buttons.forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-s9-menu-btn') === name)); });
      panels.forEach(function (p) { p.classList.toggle('is-open', p.getAttribute('data-s9-panel') === name); });
    }
    function closeMenu() { openMenu(''); }
    var menuHandlers = [];
    buttons.forEach(function (btn) {
      var name = btn.getAttribute('data-s9-menu-btn');
      var onClick = function () { if (btn.getAttribute('aria-expanded') === 'true') closeMenu(); else openMenu(name); };
      var onEnter = function () { if (fine.matches) openMenu(name); };
      btn.addEventListener('click', onClick);
      btn.addEventListener('mouseenter', onEnter);
      btn.addEventListener('focus', onEnter);
      menuHandlers.push([btn, onClick, onEnter]);
    });
    function onKey(event) { if (event.key === 'Escape') closeMenu(); }
    function onDocClick(event) { if (demo && !demo.contains(event.target)) closeMenu(); }
    function onDemoLeave() { if (fine.matches) closeMenu(); }
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', onDocClick);
    if (demo) demo.addEventListener('mouseleave', onDemoLeave);
    cleanups.push(function () {
      menuHandlers.forEach(function (h) {
        h[0].removeEventListener('click', h[1]);
        h[0].removeEventListener('mouseenter', h[2]);
        h[0].removeEventListener('focus', h[2]);
      });
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onDocClick);
      if (demo) demo.removeEventListener('mouseleave', onDemoLeave);
    });

    function applyMode() {
      if (reduced.matches) {
        if (io) { io.disconnect(); io = null; }
        unbindScroll();
        showAll();
        /* Without motion the demo wordmark rests in its header position. */
        if (demo) demo.style.setProperty('--s9-lp', '1');
        if (rail && bar) bar.style.setProperty('--s9-rail-p', '1');
        if (rail) rail.addEventListener('scroll', onRailStatic, { passive: true });
      } else {
        if (rail) rail.removeEventListener('scroll', onRailStatic);
        startReveals();
        unbindScroll();
        bindScroll();
      }
    }
    /* Reduced motion still updates the progress bar so the rail stays understandable. */
    function onRailStatic() {
      if (!rail || !bar) return;
      var max = Math.max(rail.scrollWidth - rail.clientWidth, 1);
      bar.style.setProperty('--s9-rail-p', (0.12 + clamp(rail.scrollLeft / max, 0, 1) * 0.88).toFixed(3));
    }

    root.classList.add('s9-js');
    if (!('IntersectionObserver' in window)) showAll();
    applyMode();

    function listen(query, handler) {
      if (query.addEventListener) query.addEventListener('change', handler);
      else if (query.addListener) query.addListener(handler);
    }
    function unlisten(query, handler) {
      if (query.removeEventListener) query.removeEventListener('change', handler);
      else if (query.removeListener) query.removeListener(handler);
    }
    listen(reduced, applyMode);
    listen(wide, applyMode);

    /* Touch devices only apply :active once a touch listener exists (iOS Safari). */
    function noop() {}
    root.addEventListener('touchstart', noop, { passive: true });

    teardown = function () {
      if (io) io.disconnect();
      if (pointerFrame) window.cancelAnimationFrame(pointerFrame);
      pointerFrame = 0;
      unbindScroll();
      if (rail) rail.removeEventListener('scroll', onRailStatic);
      cleanups.forEach(function (fn) { fn(); });
      unlisten(reduced, applyMode);
      unlisten(wide, applyMode);
      root.removeEventListener('touchstart', noop);
      root.classList.remove('s9-js');
      delete root.dataset.s9Ready;
      teardown = null;
    };
  }

  function ours(event) {
    var t = event && event.target;
    return !t || !t.querySelector || t.id === ROOT_ID || !!t.querySelector('#' + ROOT_ID);
  }
  function scan(event) {
    if (!ours(event)) return;
    if (teardown) teardown();
    init(document.getElementById(ROOT_ID));
  }
  function release(event) {
    if (ours(event) && teardown) teardown();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', release);
})();
